export const DEFAULT_CONFIG = {
  enabled: true,
  debug: process.env.NODE_ENV !== 'prod',
  ignoredViews: [],
  trackOnNextTick: false,
  defer: false,
  compatibility: false,
}

export default DEFAULT_CONFIG
